import { render, staticRenderFns } from "./CategoryCreate.vue?vue&type=template&id=81ccb468&"
import script from "./CategoryCreate.js?vue&type=script&lang=js&"
export * from "./CategoryCreate.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports